export default __webpack_public_path__ + "static/media/ic_directions_bus_48px.be77cc90.svg";